import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  faqItems?: FAQItem[];
}

const faqItemsDefault: FAQItem[] = [
  {
    question: "Comment accéder aux solutions de Celerinc ?",
    answer:
      "Toutes nos solutions sont accessibles en ligne avec un abonnement gratuit. Restez à l'écoute de notre page d'annonces pour découvrir les dernières nouveautés.",
  },
  {
    question: "Peut-on proposer un projet ou une idée à Celerinc ?",
    answer:
      "Oui, nous sommes ouverts à développer des solutions accessibles à tous si nous recevons suffisamment de demandes sur des sujets similaires. N'hésitez pas à nous écrire à contact@celerinc.com.",
  },
  {
    question: "Est-ce que Celerinc travaille à l'international ?",
    answer:
      "Absolument ! Nous servons une clientèle internationale et notre équipe parle plusieurs langues, dont le français, l'anglais, l'espagnol et l'arabe.",
  },
  {
    question: "Celerinc accepte-t-il des collaborations ou des partenariats ?",
    answer:
      "Oui, nous sommes ouverts à des collaborations et des partenariats pour co-créer des solutions innovantes. Contactez-nous pour en discuter.",
  },
  {
    question: "Proposez-vous des prestations sur demande ?",
    answer:
      "Les prestations sont possibles uniquement sur demande par email à contact@celerinc.com. Cependant, nous ne faisons pas de sous-traitance.",
  },
  {
    question: "Comment être informé des nouveautés de Celerinc ?",
    answer:
      "Nous lançons prochainement une option de souscription pour recevoir nos actualités et annonces directement par email.",
  },
];

export const FAQSection = (faqProps: FAQProps = {}) => {
  const faqItems = faqProps.faqItems || faqItemsDefault;

  return (
    <section
      id="faq"
      className={
        !faqProps.faqItems ? "container md:w-[700px] py-24 sm:py-32" : "py-8"
      }
    >
      <div className="text-center mb-8">
        {!faqProps.faqItems && (
          <h2 className="text-lg text-primary text-center mb-2 tracking-wider">
            FAQs
          </h2>
        )}

        <h2
          className={cn(
            "font-bold",
            !faqProps.faqItems
              ? "text-3xl md:text-4xl text-center"
              : "text-1xl md:text-2xl text-left"
          )}
        >
          Questions fréquentes
        </h2>
      </div>

      <Accordion
        type="single"
        collapsible
        className={cn(
          "AccordionRoot bg-card border px-6 py-2 rounded-lg",
          !faqProps.faqItems ? "border-secondary" : ""
        )}
      >
        {faqItems &&
          faqItems.map(({ question, answer }, index) => (
            <AccordionItem
              key={index}
              value={question}
              className={
                index === faqItems.length - 1
                  ? "border-none"
                  : "border-secondary dark:border-border"
              }
            >
              <AccordionTrigger className="text-left">
                {question}
              </AccordionTrigger>

              <AccordionContent className="text-muted-foreground">
                {answer}
              </AccordionContent>
            </AccordionItem>
          ))}
      </Accordion>

      {/* <p className="mt-4 text-sm text-muted-foreground">
        For more questions,{" "}
        <a
          href="/contact-us"
          className="text-primary dark:text-white dark:hover:text-secondary underline"
        >
          contact us
        </a>
        .
      </p> */}
    </section>
  );
};
